import { render, staticRenderFns } from "./statusComponent.vue?vue&type=template&id=23660eb6&scoped=true"
import script from "./statusComponent.vue?vue&type=script&lang=js"
export * from "./statusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23660eb6",
  null
  
)

export default component.exports